import Vue from 'vue'
const fileSaver = require('file-saver')
const XLSX = require('xlsx')

function s2ab(s) {
    const buf = new ArrayBuffer(s.length)
    const view = new Uint8Array(buf)
    for (let i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
    return buf
}

function Workbook() {
    if(!(this instanceof Workbook)) return new Workbook()
    this.SheetNames = []
    this.Sheets = {}
}

const ExcelExport = {
    install(Vue, options) {
        Vue.prototype.$excelExport = function(data, filename)
        {
            if (!filename) filename = 'export.xlsx'

            const wopts = { bookType:'xlsx', bookSST:false, type:'binary' }
            let wb = new Workbook()
            wb.SheetNames.push('export')
            // pl.: this.$refs.table.filteredData
            wb.Sheets['export'] = XLSX.utils.json_to_sheet(data)
            const wbout = XLSX.write(wb, wopts)
            fileSaver.saveAs(new Blob( [s2ab(wbout)] , {type:"application/octet-stream"} ), filename)
        }
    }
}

Vue.use(ExcelExport)

export default ExcelExport


// WEBPACK FOOTER //
// ./src/plugins/excel.js